import servicesUtils from "../../../utils/servicesUtils";
import { PatientResponse } from "../../../types/api/Patient";

const getPatientDetails = (patientUid: string) => {
  return servicesUtils.getService<PatientResponse>(`/patients/${patientUid}/`);
};

export default getPatientDetails;
